<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSppRequisitionDetSrdResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" with-custom-row-actions :edit-disable="showEditBtns"
                                      ref="emTable" import-enabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">

                              <template #customRowActions="{row}">
                                <b-button-group>

                                  <em-button type="gotoGrandParent"
                                             v-bind:class="'btn btn-outline-primary btn-sm'"
                                             @click="gotoGrandParentLevel(row)">
                                  </em-button>
                                </b-button-group>
                              </template>

                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author thq
    // Date 2021-01-10 18:11:30

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import emApiMixin from "@/mixin/em/common/api";

    export default {
        name: "emSppRequisitionDetSrdListView",
        data(){
          return{
            mainId:"",
            showEditBtns: false,
          }
        },
        mixins: [emCommonListMixin,emCommonGotoMixin,emApiMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
          modelName(){
            return this.$_emRouterHelperMixin_entityName;
          },
          entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi(this.modelName)}/`
          },

        },
        created() {
          let _this = this;
          console.log("传递的领用单主表ID =>>>" + this.$route.query.mainId);
          this.mainId = this.$route.query.mainId;
          let url = `${this.entityBaseUrl}returnWorkflowStatus`;
          console.log("url:" + url)
          this.$_emApiMixin_post(url, {sprId: this.mainId})
              .then(response => {
                    console.log("------------------------>>>>>>>>")
                    console.log(response.data)
                    console.log("------------------------<<<<<<<<")

                    _this.showEditBtns = response.data.disableEdit

                    if(_this.showEditBtns == true){
                      commonViewsUtil.showSuccess(this, "当前领用单已进入审核及领用工作流节点，不可更改！")
                    }
                    _this.$refs.emListFilter.doQuery()
                  }
              )
        },

      methods: {
        gotoGrandParentLevel(row) {
          this.$_emGotoMixin_gotoList("emSppRequisitionSpr", row.srdIdSpr ? row.srdIdSpr : "",{mainId:this.mainId})
        }
      }
    };
</script>